import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SeleccionPolizaDialogComponent } from './seleccion-poliza-dialog.component';
import { FormBuilder, FormGroup, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { OvService } from './service/ov.service';


@Component({
  selector: 'app-descarga-poliza',
  templateUrl: './descarga-poliza.component.html',
  styleUrls: ['./descarga-poliza.component.css'],
  standalone: false
})
  export class DescargaPolizaComponent implements OnInit {
    formPoliza: FormGroup;
    poliza: string | null = null;
    certificado: string | null = null;
    cupones: string | null = null;
    mensajeError: string | null = null;
    isLoading: boolean = false;
    textoLoading: string = 'Buscando...';
    isBusquedaRealizada: boolean = false;

    poliza_id_seleccionada: string | null = null;
    poliza_num_seleccionada: string | null = null;

    constructor(
      private fb: FormBuilder,
      private ovService: OvService,
      private cdr: ChangeDetectorRef,
      private dialog: MatDialog
    ) {
      this.formPoliza = this.fb.group({
        ramo: ['auto', Validators.required],
        patente: [''],
        documento: ['']
      }, { validators: this.autoMotoValidator() });
    }

    ngOnInit(): void {
      this.formPoliza.valueChanges.subscribe(() => {
        this.isBusquedaRealizada = false;
      });


      this.formPoliza.get('ramo')?.valueChanges.subscribe(ramo => {
        if (ramo === 'auto' || ramo === 'moto') {
          // No requerimos ambos, solo uno, así que quitamos required individuales
          this.formPoliza.get('patente')?.clearValidators();
          this.formPoliza.get('documento')?.clearValidators();
        } else {
          // Para praxis, documento sí es requerido
          this.formPoliza.get('patente')?.clearValidators();
          this.formPoliza.get('patente')?.setValue('');
          this.formPoliza.get('documento')?.setValidators([Validators.required]);
        }
        this.formPoliza.get('patente')?.updateValueAndValidity();
        this.formPoliza.get('documento')?.updateValueAndValidity();
        this.formPoliza.updateValueAndValidity();
      });
    }

    // Validador personalizado: para auto/moto, al menos uno de los dos campos debe estar completo
    autoMotoValidator(): ValidatorFn {
      return (group: AbstractControl) => {
        const ramo = group.get('ramo')?.value;
        const patente = group.get('patente')?.value;
        const documento = group.get('documento')?.value;
        if (ramo === 'auto' || ramo === 'moto') {
          if (!patente && !documento) {
            return { unoRequerido: true };
          }
        } else if (ramo === 'praxis') {
          if (!documento) {
            return { documentoRequerido: true };
          }
        }
        return null;
      };
    }

    onSubmit() {
      if (this.formPoliza.valid && !this.isBusquedaRealizada) {
        this.isBusquedaRealizada = true;
        this.isLoading = true;
        this.textoLoading = 'Buscando...';
        this.mensajeError = null;
        this.poliza = null;
        this.certificado = null;
        const ramo = this.formPoliza.get('ramo')?.value;
        let r = '';
        if (ramo === 'auto') {
          r = '4';
        } else if (ramo === 'moto') {
          r = '3';
        } else if (ramo === 'praxis') {
          r = '30';
        }

        const uuid = localStorage.getItem('uuid');
        const token = localStorage.getItem('token');
        if (uuid && token) {
          this.ovService.obtener_pdf(token, uuid, this.formPoliza.value.documento, r, this.formPoliza.value.patente, 'consulta', null, null).subscribe({
            next: (response) => {
              this.isLoading = false;
              if (response.tipo_respuesta === 'error') {
                this.mensajeError = 'No encontramos ningún documento para los datos ingresados.';
                this.cdr.detectChanges();
                return;
              } else if (response.tipo_respuesta === 'documentos') {
                this.poliza = response.pdf_poliza_base64;
                this.certificado = response.pdf_mercosur_base64;
                this.cupones = response.pdf_cupones_base64;
                if (!this.poliza && !this.certificado) {
                  this.mensajeError = 'No encontramos ningún documento para los datos ingresados.';
                }
              this.cdr.detectChanges();
              } else if (response.tipo_respuesta === 'resumen') {
                if (response.polizas && response.polizas.length > 0) {
                  const dialogRef = this.dialog.open(SeleccionPolizaDialogComponent, {
                    width: '350px',
                    data: { polizas: response.polizas }
                  });
                  dialogRef.afterClosed().subscribe((result) => {
                    if (result && result.poliza_id && result.poliza_num) {
                      this.isLoading = true;
                      this.poliza_id_seleccionada = result.poliza_id;
                      this.poliza_num_seleccionada = result.poliza_num;
                      this.ovService.obtener_pdf(token, uuid, this.formPoliza.value.documento, r, this.formPoliza.value.patente, 'documentos', result.poliza_id, result.poliza_num).subscribe({
                        next: (response) => {
                          if (response.tipo_respuesta === 'error') {
                            this.isLoading = false;
                            this.mensajeError = 'No encontramos ningún documento para los datos ingresados.';
                            this.cdr.detectChanges();
                            return;
                          } else if (response.tipo_respuesta === 'documentos') {
                            this.isLoading = false;
                            this.poliza = response.pdf_poliza_base64;
                            // Solo asignar certificado para ramos 3 (moto) y 4 (auto)
                            const ramo = this.formPoliza.get('ramo')?.value;
                            if (ramo === 'auto' || ramo === 'moto') {
                              this.certificado = response.pdf_mercosur_base64;
                            } else {
                              this.certificado = null;
                            }
                            this.cupones = response.pdf_cupones_base64;
                            if (!this.poliza && !this.certificado) {
                              this.mensajeError = 'No encontramos ningún documento para los datos ingresados.';
                            }
                            this.cdr.detectChanges();
                          }
                        },
                        error: (error) => {
                          this.isLoading = false;
                          this.mensajeError = 'Ocurrió un error al buscar los documentos. Intente nuevamente.';
                          console.error('Error al obtener el PDF:', error);
                        }
                      });
                    } else {
                      // Si el usuario cierra el modal sin seleccionar, limpiar estado y formulario
                      this.poliza = null;
                      this.certificado = null;
                      this.cupones = null;
                      this.mensajeError = null;
                      this.formPoliza.reset({ ramo: 'auto', patente: '', documento: '' });
                      this.cdr.detectChanges();
                    }
                  });

                } else {
                  this.mensajeError = 'No se encontraron pólizas asociadas.';
                  this.cdr.detectChanges();
                }
              }

            },
            error: (error) => {
              this.isLoading = false;
              this.mensajeError = 'Ocurrió un error al buscar los documentos. Intente nuevamente.';
              console.error('Error al obtener el PDF:', error);
            }
          });
        }
      }

    }

    descargarPoliza() {
      if (this.poliza && this.poliza.length > 100) {
        const pdfWindow = window.open();
        if (pdfWindow) {
          pdfWindow.document.write(
            `<iframe width='100%' height='100%' src='data:application/pdf;base64,${this.poliza}'></iframe>`
          );
        }
      } else {
        alert('No hay póliza disponible para descargar.');
      }
    }

    descargarCertificado() {
      if (this.certificado && this.certificado.length > 100) {
        const pdfWindow = window.open();
        if (pdfWindow) {
          pdfWindow.document.write(
            `<iframe width='100%' height='100%' src='data:application/pdf;base64,${this.certificado}'></iframe>`
          );
        }
      } else {
        alert('No hay certificado disponible para descargar.');
      }
    }

    descargarCupones() {
      if (this.cupones && this.cupones.length > 100) {
        const pdfWindow = window.open();
        if (pdfWindow) {
          pdfWindow.document.write(
            `<iframe width='100%' height='100%' src='data:application/pdf;base64,${this.cupones}'></iframe>`
          );
        }
      } else {
        alert('No hay cupones disponible para descargar.');
      }
    }
}

